export enum Guide {
  FUTURE_TXN_CREATED = 'FUTURE_TXN_CREATED',
}

export const guidePreferenceMap = {
  [Guide.FUTURE_TXN_CREATED]: {
    web: 'sFutureTxnGuideWeb',
    mobile: 'sFutureTxnGuideMobile',
  },
} as const;
